import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface CategoryListPageProps extends NSARouterMakerResult, FieldProps { }

export default function CategoryListPage(props: CategoryListPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays all categories you have created with their basic information."
			}}
			pages={{
				entity: FieldEntities.category(props),
				list: {}
			}}
		>
			<>
			</>
		</FieldLayout>
	);
}